export type TextCaseMode = 'title' | 'lower' | 'upper';

export function formatTextCase(value: string, mode: TextCaseMode): string {
    if (!value) {
        return value;
    }

    if (mode === 'lower') {
        return value.toLowerCase();
    }

    if (mode === 'upper') {
        return value.toUpperCase();
    }

    return toTitleCase(value);
}

function toTitleCase(value: string): string {
    const lower = value.toLowerCase();
    const parts = lower.split(/(\s+)/);

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (part.trim().length === 0) {
            continue;
        }

        parts[i] = titleCaseWordWithDelimiters(part);
    }

    return parts.join('');
}

function titleCaseWordWithDelimiters(word: string): string {
    const tokens = word.split(/([-'])/);

    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];

        if (token === '-' || token === "'") {
            continue;
        }

        if (!token) {
            continue;
        }

        tokens[i] = token.slice(0, 1).toUpperCase() + token.slice(1);
    }

    return tokens.join('');
}